import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "error text-dark" }
const _hoisted_2 = {
  key: 0,
  class: "error-id text-muted"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_fa = _resolveComponent("fa")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, _toDisplayString(_ctx.message), 1 /* TEXT */),
    (_ctx.code != null)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, "Код ошибки: " + _toDisplayString(_ctx.code), 1 /* TEXT */))
      : _createCommentVNode("v-if", true),
    _createElementVNode("span", {
      class: "error-dismiss",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('delete')))
    }, [
      _cache[1] || (_cache[1] = _createTextVNode(" ", -1 /* CACHED */)),
      _createVNode(_component_fa, { icon: "xmark" })
    ])
  ]))
}